















































































































































































import Vue from "vue"
import {Component} from "vue-property-decorator"
import ScrollTo from "vue-scrollto"
Vue.use(ScrollTo);

/**
 * You can use `@/` as an equivalent for `./src`
 */
//import LocaleChanger from "@/components/LocaleChanger.vue";
import ThemeChanger from "@/components/ThemeChanger.vue";
import Slideshow from "@/components/Slideshow.vue";

/**
 * @Component decorator is used to declare a Vue Component
 * and including Component into the Vue instance
 */
@Component({
  name: "App",
  components: {
    ThemeChanger,
    Slideshow
  }
})
export default class App extends Vue {
}
